import { logo } from "../services/index.path";
export class PublicationModel{
    id?:number;
    user_id?:string;
    title?:string;
    comment?:string;
    latitude_publication?:string;
    longitude_publication?:string;
    latitude_event?:string;
    longitude_event?:string;
    datetime_event?:string;
    device_model?:string;
    device_uuid?:string;
    views?:string;
    fileraw?:File;
    file?:string;
    private?:string;
    device_type?:string;
    user?: {
      id?: number,
      name?: string,
      email?: string,
      username?: string,
      credits?: number,
      recommended_by?: string,
      deleted_at?: string,
      created_at?: string,
      updated_at?: string
    }
  
    constructor(){
      
      if(!this.user){
        this.user = {
          username:"Comunidad TimePlaceBook"
        }
      }
    }
  
  }


// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/nmodels/publication.model.ts